import { Link } from "react-router-dom";
import CustomNavIcon from "./CustomNavIcon";

export default function Header() {
    return (
        <header>
            <div className="logo">
                <img src="https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg" alt="Logo" />
            </div>
            <h1>amantes30</h1>
            <nav>
                <ul className="nav-links">
                    <li><Link to="/"><CustomNavIcon label="Home"/></Link></li>
                    <li><Link to="/about"><CustomNavIcon label="About"/></Link></li>
                    <li><Link to="/faq"><CustomNavIcon label="FAQ"/></Link></li>
                    <li><Link to="/contact"><CustomNavIcon label="Contact"/></Link></li>
                </ul>
            </nav>
        </header>
    );
}
